import __request__ from "routing/request";
export function getFavoriteItems(page = 1, per_page = 5, type, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.views/favorites", null, { "page": page, "per_page": per_page, "type": type }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeItemFromFavorites(grn, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.views/favorites/${grn}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addItemToFavorites(grn, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.views/favorites/${grn}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
